import { initBotId } from "botid/client/core";
import posthog from "posthog-js";
import { registerDesktopAppContext } from "@/lib/desktop/desktop-analytics";
import {
  createPostHogBrowserConfig,
  shouldInitializePostHog,
} from "@/lib/posthog-browser-config";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const shouldInitPosthog = shouldInitializePostHog(
  process.env.NEXT_PUBLIC_POSTHOG_ENABLED
);

if (shouldInitPosthog) {
  if (!posthogKey) {
    throw new Error("NEXT_PUBLIC_POSTHOG_KEY is not set");
  }

  posthog.init(
    posthogKey,
    createPostHogBrowserConfig({
      apiHost: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      nodeEnv: process.env.NODE_ENV,
    })
  );
  registerDesktopAppContext();
}

// Define the paths that need bot protection.
// These are paths that are routed to by your app.
// These can be:
// - API endpoints (e.g., '/api/checkout')
// - Server actions invoked from a page (e.g., '/dashboard')
// - Dynamic routes (e.g., '/api/create/*')

// BotID already bypasses server checks in development. Do not load its
// secure-context-only browser challenge on local HTTP hosts.
if (process.env.NODE_ENV === "production") {
  initBotId({
    protect: [
      {
        path: "/auth/*",
        method: "POST",
      },
      {
        path: "/accept-invitation/*",
        method: "POST",
      },
      {
        path: "/api/afip/delegation",
        method: "POST",
      },
      {
        path: "/api/upload-logo",
        method: "POST",
      },
      {
        path: "/api/upload-logo",
        method: "DELETE",
      },
      {
        path: "/api/upload-product-image",
        method: "POST",
      },
      {
        path: "/api/upload-product-image",
        method: "DELETE",
      },
      {
        path: "/api/upload-variant-group-image",
        method: "POST",
      },
      {
        path: "/api/upload-variant-group-image",
        method: "DELETE",
      },
    ],
  });
}
